import { useDispatch } from "react-redux"
import { push } from "src/features/Notification/notificationSlice"

function CustomNotifications() {
  const dispatch = useDispatch()

  const showError = (text = `There's an error occurred, please try again.`) => {
    let error_text = text
    if (text === "มีข้อมูลในในระบบแล้ว") {
      error_text = "Hang on, this information has been created."
    }
    dispatch(
      push({
        title: "Error",
        description: error_text,
        severity: "error",
      })
    )
  }

  const showSuccess = () => {
    dispatch(
      push({
        title: "Success",
        description: "The action has done successfully! ",
        severity: "success",
      })
    )
  }

  const showInfo = (text) => {
    dispatch(
      push({
        title: "Info",
        description: text,
        severity: "info",
      })
    )
  }

  return { showError, showSuccess, showInfo }
}

export default CustomNotifications
